import React from "react";
import { brand } from "../theme/palette";

const WorkInProgress = () => {
  return (
    <div className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-black via-gray-900 to-black overflow-hidden">
      {/* Floating particles with glow */}
      {Array.from({ length: 12 }).map((_, i) => (
        <div
          key={i}
          className="absolute w-2 h-2 bg-gradient-to-r from-blue-400 to-brand-400 rounded-full animate-float shadow-lg"
          style={{ 
            left: `${(i + 1) * 8}%`, 
            animationDelay: `${i * 0.7}s`,
            boxShadow: `0 0 10px ${brand[500]}80`
          }}
        ></div>
      ))}

      {/* Additional ambient particles */}
      {Array.from({ length: 8 }).map((_, i) => (
        <div
          key={`ambient-${i}`}
          className="absolute w-1 h-1 bg-white rounded-full animate-twinkle"
          style={{ 
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
            animationDelay: `${i * 1.2}s`
          }}
        ></div>
      ))}

      <div className="relative text-center bg-black/40 backdrop-blur-xl rounded-3xl p-12 max-w-md w-[90%] shadow-2xl border border-white/10 overflow-hidden">
        {/* Glass morphism effect overlay */}
        <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-white/0 rounded-3xl"></div>
        
        <div className="relative z-10 mb-8 flex justify-center">
          <div className="relative">
            {/* Outer glow ring */}
            <div className="absolute inset-0 w-28 h-28 md:w-32 md:h-32 bg-gradient-to-br from-blue-400 via-brand-500 to-brand-500 rounded-full animate-pulse opacity-20 blur-lg"></div>
            
            {/* Main spinner container */}
            <div className="relative w-20 h-20 md:w-24 md:h-24 bg-gradient-to-br from-blue-500 via-brand-600 to-brand-600 rounded-full flex items-center justify-center animate-bounce shadow-2xl">
              <div className="w-10 h-10 md:w-12 md:h-12 border-4 border-white rounded-full animate-spin relative">
                <div
                  className="absolute top-[-8px] left-1/2 -translate-x-1/2 w-2 h-2 bg-white rounded-full shadow-lg"
                  style={{
                    boxShadow:
                      "0 16px 0 white, 16px 8px 0 white, -16px 8px 0 white, 12px -12px 0 white, -12px -12px 0 white, 12px 28px 0 white, -12px 28px 0 white",
                  }}
                ></div>
              </div>
            </div>
          </div>
        </div>

        <h1 className="relative z-10 text-3xl md:text-4xl font-bold text-white mb-4 animate-fadeInUp">
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-white via-blue-200 to-brand-200 drop-shadow-lg">
            We're Building Something Amazing
          </span>
        </h1>
        
        <p className="relative z-10 text-gray-300 mb-8 text-sm md:text-base leading-relaxed animate-fadeInUp animate-delay-300 drop-shadow-md">
          Our team is working hard to bring you an exceptional experience. Stay
          tuned for something incredible!
        </p>

        <div className="relative z-10 w-full h-3 bg-white/10 rounded-full overflow-hidden mb-3 shadow-inner">
          <div className="h-full w-full bg-gradient-to-r from-blue-400 via-brand-500 to-brand-500 rounded-full animate-loading bg-[length:200%_100%] shadow-lg"></div>
        </div>

        <p className="relative z-10 text-gray-400 text-xs animate-pulse font-medium">
          Almost ready...
        </p>

        {/* Decorative elements */}
        <div className="absolute top-4 right-4 w-8 h-8 border border-white/20 rounded-full animate-spin-slow"></div>
        <div className="absolute bottom-4 left-4 w-6 h-6 border border-white/20 rounded-full animate-spin-reverse"></div>
      </div>

      {/* Custom animations */}
      <style>
        {`
          @keyframes float {
            0% { transform: translateY(100vh) scale(0); opacity: 0; }
            10% { opacity: 1; transform: scale(1); }
            90% { opacity: 1; }
            100% { transform: translateY(-100vh) scale(0); opacity: 0; }
          }
          .animate-float { animation: float 8s linear infinite; }

          @keyframes twinkle {
            0%, 100% { opacity: 0; transform: scale(0); }
            50% { opacity: 1; transform: scale(1); }
          }
          .animate-twinkle { animation: twinkle 3s ease-in-out infinite; }

          @keyframes bounce {
            0%,20%,60%,100% { transform: translateY(0); }
            40% { transform: translateY(-20px); }
            80% { transform: translateY(-10px); }
          }
          .animate-bounce { animation: bounce 2s infinite; }

          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
          .animate-spin { animation: spin 4s linear infinite; }

          @keyframes spin-slow {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
          .animate-spin-slow { animation: spin-slow 8s linear infinite; }

          @keyframes spin-reverse {
            from { transform: rotate(360deg); }
            to { transform: rotate(0deg); }
          }
          .animate-spin-reverse { animation: spin-reverse 6s linear infinite; }

          @keyframes fadeInUp {
            from { opacity: 0; transform: translateY(30px); }
            to { opacity: 1; transform: translateY(0); }
          }
          .animate-fadeInUp { animation: fadeInUp 1s ease-out forwards; }
          .animate-delay-300 { animation-delay: 0.3s; }

          @keyframes loading {
            0% { width: 0%; background-position: 200% 0; }
            50% { width: 75%; }
            100% { width: 100%; background-position: -200% 0; }
          }
          .animate-loading { animation: loading 3s ease-in-out infinite; }

          @keyframes pulse {
            0%, 100% { opacity: 0.4; }
            50% { opacity: 0.8; }
          }
        `}
      </style>
    </div>
  );
};

export default WorkInProgress;